import { Intercom } from '@capacitor-community/intercom';
import { Capacitor } from '@capacitor/core';

const plateform = import.meta.env.VITE_APP_INTERCOM_PLATEFORM_KEY;
const env = import.meta.env.VITE_DATADOG_ENV;
const appId = import.meta.env.VITE_INTERCOM_APP_ID;
const apiKeyIOS = import.meta.env.VITE_INTERCOM_IOS_API_KEY;

export function initIntercomForCapacitor(groupId?: string) {
  // Only execute this code if we are in native plateform
  if (Capacitor.isNativePlatform()) {
    Intercom.loadWithKeys({ appId, apiKeyIOS });
    Intercom.registerUnidentifiedUser();
    // Since user is not identified, set some custom attributes to be able to segment users in Intercom
    Intercom.updateUser({
      customAttributes: {
        app_platform: plateform,
        app_env: env,
        app_group_id: groupId || 'no_group',
      },
    });
    // Force hide launcher since we don't want this feature to be available
    Intercom.hideLauncher();
  }
}
